/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import PreviousLegRow from "./PreviousLegRow";

const StyledTableCell = styled(({ theme, ...props }) => (
  <TableCell {...props} />
))`
  border-bottom: none !important;
  color: ${(props) => props.theme.palette.text.secondary} !important;
  font-weight: 400 !important;
  padding: 2px !important;
`;

function PreviousLegsDetails({ legs }) {
  const theme = useTheme();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell variant="head" theme={theme}>
              {/* Empty column to align this table's columns with scheduled legs table's columns */}
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              Leg
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              Status
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              Srv
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              SLOC
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              Actual Start
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              ELOC
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              Actual End
            </StyledTableCell>
            <StyledTableCell variant="head" theme={theme}>
              Miles
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {legs.map((leg) => (
            <PreviousLegRow key={leg.id} leg={leg} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

PreviousLegsDetails.propTypes = {
  legs: PropTypes.array.isRequired,
};

export default PreviousLegsDetails;
